import { createSelector } from "@reduxjs/toolkit"
import { type Address, getAddress } from "viem"
import type { Collaterals } from "../actions/simulation"
import type { EnabledVaultsInfo } from "../types"

export const reduceCollaterals = createSelector(
  [(accountStatus: EnabledVaultsInfo[]) => accountStatus],
  (accountStatus) => {
    const data = new Map<Address, Map<Address, Collaterals>>()
    for (const status of accountStatus) {
      if (!status) continue
      const { evcAccountInfo, vaultAccountInfo } = status
      const account = evcAccountInfo.account
      const collaterals = new Map<Address, Collaterals>()
      for (const info of vaultAccountInfo) {
        const { vault, shares, isCollateral, liquidityInfo } = info
        collaterals.set(getAddress(vault), {
          shares,
          queryFailure: liquidityInfo.queryFailure,
          queryReason: liquidityInfo.queryFailureReason,
          collateralValueLiquidation: liquidityInfo.collateralValueLiquidation,
          collateralValueBorrowing: liquidityInfo.collateralValueBorrowing,
          isEnabledCollateral: isCollateral,
        })
      }
      if (collaterals.size > 0) {
        data.set(getAddress(account), collaterals)
      }
    }

    return data
  },
)
